var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-startstop" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "section",
        [
          _c(
            "b-field",
            {
              attrs: { label: "実績値を入力して、送信ボタンを押してください。" }
            },
            [
              _c("form", { ref: "form" }, [
                _c(
                  "div",
                  { staticClass: "input-amount" },
                  [
                    _c("b-numberinput", {
                      attrs: {
                        placeholder: "100",
                        min: 0,
                        max: "99999",
                        size: "is-large",
                        type: "is-success"
                      },
                      model: {
                        value: _vm.inputNumber,
                        callback: function($$v) {
                          _vm.inputNumber = $$v
                        },
                        expression: "inputNumber"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { size: "is-large", disabled: _vm.isDisabled },
              on: { click: _vm.save_work_clicked }
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-loading", {
        staticStyle: { "background-color": "rgba(0, 0, 0, 0.8)" },
        attrs: { "is-full-page": true, "can-cancel": false },
        model: {
          value: _vm.isLoading,
          callback: function($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "title-bar" }, [
      _c("div", { staticClass: "hero-body" }, [
        _c("p", { staticClass: "title" }, [_vm._v("作業量の入力")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("送信する作業量を入力してください")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-519321c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519321c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputAmount.vue
// module id = 4qdd
// module chunks = 0